var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 6.6276V11.6276C18.8333 12.8776 18.4166 13.9193 17.6833 14.6526C16.9583 15.3776 15.9166 15.7943 14.6666 15.7943V17.5693C14.6666 18.2359 13.925 18.636 13.375 18.2693L9.66663 15.7943H7.89996C7.96663 15.5443 7.99996 15.2859 7.99996 15.0193C7.99996 14.1693 7.67496 13.386 7.14163 12.7943C6.54163 12.111 5.64996 11.6859 4.66663 11.6859C3.73329 11.6859 2.8833 12.0693 2.27496 12.6943C2.19996 12.361 2.16663 12.0026 2.16663 11.6276V6.6276C2.16663 4.1276 3.83329 2.46094 6.33329 2.46094H14.6666C17.1666 2.46094 18.8333 4.1276 18.8333 6.6276Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.0208C8.00004 15.2875 7.96671 15.5458 7.90004 15.7958C7.82504 16.1292 7.69172 16.4542 7.51672 16.7375C6.94172 17.7042 5.88337 18.3542 4.66671 18.3542C3.80837 18.3542 3.03337 18.0291 2.45004 17.4958C2.20004 17.2791 1.98336 17.0208 1.8167 16.7375C1.50836 16.2375 1.33337 15.6458 1.33337 15.0208C1.33337 14.1208 1.69171 13.2959 2.27504 12.6959C2.88338 12.0709 3.73337 11.6875 4.66671 11.6875C5.65004 11.6875 6.54171 12.1125 7.14171 12.7958C7.67504 13.3875 8.00004 14.1708 8.00004 15.0208Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55829 15.8872L3.79163 14.1289",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54169 14.1523L3.77502 15.9107",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58337 9.1875H13.4167",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRemove);
export default __webpack_public_path__ + "static/media/message-remove.9f87927fe52fe37e76f9a9fd9fb52d9f.svg";
export { ForwardRef as ReactComponent };